import Axios from 'axios';

const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:9000' : '';
let axios = createInstance();

export default axios;

function createInstance() {
  const token = window.localStorage.getItem('token');

  const instance = Axios.create({
    baseURL
  });

  instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  if (token) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  return instance;
}
